import { BaseOption } from 'ui/selectv2/types';
import { getListOptions } from '../../utils';
import { List } from '../../../../types';

export const convertListIdsToOptions = (listIds: string[], lists: List[]): BaseOption<string>[] => {
  const filteredLists = lists.filter(({ id }) => listIds.includes(id.toString()));
  return getListOptions(filteredLists);
};
